import React from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as ExplanationOne } from './explanation-1.svg';
import { ReactComponent as ExplanationTwo } from './explanation-2.svg';
import { ReactComponent as ExplanationThree } from './explanation-3.svg';
import Step from '../BuildingBlocks/Stepper/Step';
import { Carousel } from '@8fig/carousel';
import Typography from '@material-ui/core/Typography';
import { EXPLANATIONS } from '../messages';

const useStyles = makeStyles((theme: any) => ({
  img: {
    [theme.breakpoints.down('sm')]: {
      maxHeight: 200,
    },
  },
}));

export default function EightFigExplanation() {
  const classes = useStyles();
  const mobile = useMobile('sm');

  const { goForward } = useOnboardingContext();

  const carouselPages = [
    {
      image: <ExplanationOne className={classes.img} />,
      description: EXPLANATIONS.explanation_1,
    },
    {
      image: <ExplanationTwo className={classes.img} />,
      description: EXPLANATIONS.explanation_2,
    },
    {
      image: <ExplanationThree className={classes.img} />,
      description: EXPLANATIONS.explanation_3,
    },
  ];

  return (
    <Step
      onSubmit={goForward}
      hideBackButton={true}
      nextButtonText={`Let's get started!`}
      component={() => (
        <Carousel
          pages={carouselPages.map(({ image }) => {
            return {
              page: <>{image}</>,
            };
          })}
          textBelowCarousel={carouselPages.map(({ description }) => (
            <Typography gutterBottom variant={mobile ? 'body1' : 'h6'}>
              {description}
            </Typography>
          ))}
        />
      )}
    />
  );
}
